module.exports = __webpack_public_path__ + "static/media/avatar.dc72c7b5.jpg";